<template>
  <router-view />

  <div id="modal-container">
    <FBChat />
  </div>
  
  <Teleport to="body">
    <CookieConsent v-if="showCookieConsent" />
    <div v-if="!isEnglishTestPage" class="floating-test-button">
      <a href="https://ned.ie/english-test.html" class="test-english-btn">
        <span class="test-icon"><i class="fas fa-language"></i></span>
        <span class="test-text">Test Your English</span>
      </a>
    </div>
  </Teleport>
</template>

<script setup>
import FBChat from "@/components/FBChat.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

// Use a ref to control when to show the cookie consent
const showCookieConsent = ref(false);
const route = useRoute();

// Determine if current page is an English test page
const isEnglishTestPage = computed(() => {
  return route.name === 'english_test' || route.name === 'english_test_questions';
});

// Only show the cookie banner from the root App.vue, not in nested router views
onMounted(() => {
  // Check if this is the root instance (not a nested router-view instance)
  // We use a timeout to ensure we don't interfere with other components
  setTimeout(() => {
    if (!window.rootAppMounted) {
      window.rootAppMounted = true;
      showCookieConsent.value = true;
    }
  }, 100);
});
</script>

<style>
.floating-test-button {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.test-english-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(45deg, var(--blue1), var(--blue2));
  color: white;
  padding: 12px 20px 12px 15px;
  text-decoration: none;
  border-radius: 30px 0 0 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.test-english-btn:hover {
  padding-right: 25px;
  color: white;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
}

.test-icon {
  background-color: rgba(255, 255, 255, 0.2);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 18px;
}

.test-text {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .test-english-btn {
    padding: 10px;
  }
  
  .test-text {
    display: none;
  }
  
  .test-icon {
    margin-right: 0;
  }
  
  .test-english-btn:hover {
    padding-right: 15px;
  }
}
</style>
